import { styled } from "@mui/material"

export const Container = styled("div")(() => ({
    width: "100%",
    height: "100%",
}))